import {Discount} from "../../Models/discount";
import {Pipe, PipeTransform} from '@angular/core';
import {map} from 'rxjs/operators';
import {timer} from "rxjs";
import {DiscountServiceService} from "../../Services/discount-service.service";

@Pipe({
    name: 'countdownTimer',
    standalone: false
})
export class countdownTimerPipe implements PipeTransform {


  constructor(private discountServiceService:DiscountServiceService) {

  }

  //time between actual date and promo EndingDate
  private getTimeDifference = (endingDate: Date): number => ((new Date(endingDate).getTime()) - new Date().getTime());

  //
  private msToTime(timeDifference: number): string | null {
    if (timeDifference < 0) {
      return null;
    }

    let seconds: string | number = Math.floor((timeDifference / 1000) % 60),
      minutes: string | number = Math.floor((timeDifference / (1000 * 60)) % 60),
      hours: string | number = Math.floor((timeDifference / (1000 * 60 * 60)) % 24),
      days: string | number = Math.floor((timeDifference) / (1000 * 60 * 60 * 24));

    //Add the relevant `0` prefix if any of the numbers are less than 10
    seconds = (seconds < 10) ? '0' + seconds : seconds;
    minutes = (minutes < 10) ? '0' + minutes : minutes;
    hours = (hours < 10) ? '0' + hours : hours;
    days = (days < 10) ? '0' + days : days;

    if (days === "00" && hours === "00" && minutes === "00" && seconds === "00") {
      return null
    }

    if (days === "00" && hours === "00" && minutes === "00") {
      return seconds + "s";
    }

    if (days === "00" && hours === "00") {
      return minutes + "m " + seconds + "s";
    }

    if (days === "00") {
      return hours + "h " + minutes + "m " + seconds + "s";
    }

    return days + "j " + hours + "h " + minutes + "m " + seconds + "s";

  }

  public transform(discount: Discount) {

    //convert the date timing to CET ALG offset (GMT+1)
    const endPromoDate = this.discountServiceService.convertUTCDateToLocalAlgOffset(new Date(discount.endingDate));

    if (!endPromoDate || this.getTimeDifference(endPromoDate) < 0) {
      return null;
    }

    return timer(0, 1000).pipe(
      map(() => {
        return this.msToTime(this.getTimeDifference(endPromoDate));
      })
    );
  }
}
